import { TRACKER_MESSAGE_TRANSPORT } from '@racemap/sdk/schema/trackers';
import { Form, Select } from 'antd';
import type { FC } from 'react';

const Option = Select.Option;

export const ChooseTransportSelect: FC = () => {
  const form = Form.useFormInstance();

  const handleTransportChange = (value: TRACKER_MESSAGE_TRANSPORT) => {
    if (value === TRACKER_MESSAGE_TRANSPORT.SMS) {
      form.resetFields(['plannedAt', 'closeAfter', 'forceNow']);
      form.setFieldValue('forceNow', true);
    }
  };

  return (
    <Form.Item label="Transport" name="transport">
      <Select onChange={handleTransportChange}>
        <Option value={TRACKER_MESSAGE_TRANSPORT.TCP}>TCP</Option>
        <Option value={TRACKER_MESSAGE_TRANSPORT.SMS}>SMS</Option>
      </Select>
    </Form.Item>
  );
};
